import { ExhaustivenessError } from 'ComponentLibrary/src/common/error/error'
import { decimalToLocalizedString } from 'ComponentLibrary/src/common/numbers'

type Wault = number | 'unlimited' | undefined

type WaultLabels = {
    unknown: string
    unlimited: string
    year: string
    years: string
}

const DEFAULT_WAULT_LABELS: WaultLabels = {
    unknown: 'Unbekannt',
    unlimited: 'Unbefristet',
    year: 'Jahr',
    years: 'Jahre',
}

/**
 * Formats a `Wault` value with caller-provided labels.
 *
 * - Returns the localized `unknown` label if `wault` is `undefined` with no unit.
 * - Returns the localized `unlimited` label if `wault` equals `unlimited` with no unit.
 * - If `wault` is a number, it is formatted with one decimal place with the localized `year` or `years` unit.
 */
export function getFormattedValueAndUnitFromWault(
    wault: Wault,
    labels: WaultLabels = DEFAULT_WAULT_LABELS,
    locale = 'de-DE'
): { value: string; unit?: string } {
    if (wault === undefined) {
        return { value: labels.unknown }
    }

    if (wault === 'unlimited') {
        return { value: labels.unlimited }
    }

    if (typeof wault === 'number') {
        return { value: decimalToLocalizedString(wault, false, 1, undefined, locale), unit: getWaultUnit(wault, labels) }
    }

    throw ExhaustivenessError(wault)
}

function getWaultUnit(wault: Wault, labels: WaultLabels) {
    if (typeof wault === 'number') {
        return wault <= 1 ? labels.year : labels.years
    }
    return undefined
}
